module.exports = __webpack_public_path__ + "static/media/Movingful-MWDG-Final-Grey.7c84b8ac.svg";